import { render, staticRenderFns } from "./phoneElement.vue?vue&type=template&id=1d59faf2&scoped=true"
import script from "./phoneElement.vue?vue&type=script&lang=js"
export * from "./phoneElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d59faf2",
  null
  
)

export default component.exports